import React, { useState } from 'react';
import download from '../utils/downloadExcel';
import Config from '../config/Config';
import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';

function OnlineDataExport(props) {
    const { restauId, startDate, endDate } = props;
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const reportNamePrefix = 'OnlineOrdersReport_';

    // to export the data related to all the items from all the Online orders
    async function exportOnlineOrderData() {
        setLoading((prevstatus) => !prevstatus);
        setIsError(false);
        const token = await window.customerApp.auth().currentUser.getIdToken();
        let config = {
            headers: {
                token: token,
            },
        };

        let reqBody = {
            restauId: restauId,
            startDate: startDate,
            endDate: endDate,
        };

        let dataToExport = [];

        axios
            .post(Config.getOnlineOrdersReport, reqBody, config)
            .then((response) => {
                console.log(response.data);
                //debugger;
                if (response.data.sales) {
                    response.data.sales.forEach((element) => {
                        dataToExport.push({
                            OrderId: element.id,
                            Date: element.date,
                            OrderNumber: element.orderNumber,
                            SubTotal: element.subTotal,
                            SalesTax: element.salesTax,
                            CreditCardFee: element.creditCardFee,
                            Tips: element.tip,
                            Total: element.total,
                            Type: element.type,
                        });
                    });

                    setLoading((prevstatus) => !prevstatus);
                    download.excelDownload(
                        dataToExport,
                        reportNamePrefix +
                            moment(new Date()).format('DD-MM-YYYY_hhmmss') +
                            '.xlsx',
                        'OnlineOrders'
                    );
                } else {
                    setLoading((prevstatus) => !prevstatus);
                    setIsError(true);
                }
            })
            .catch(function (error) {
                setLoading((prevstatus) => !prevstatus);
                setIsError(true);
                console.log(error);
            });
    }

    return (
        <>
            <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={() => exportOnlineOrderData()}
            >
                Export to Excel
            </Button>
            {loading && <CircularProgress color="secondary" size={30} />}
            {isError && (
                <p
                    style={{
                        color: 'red',
                        fontWeight: 'normal',
                        fontSize: '0.85rem',
                    }}
                >
                    Failed to export the data.
                </p>
            )}
        </>
    );
}

OnlineDataExport.propTypes = {
    restauId: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date),
};

export default OnlineDataExport;
